/** @format */

export const touchSize = 1024;
